import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { useSelector, } from 'react-redux';
import { Card, Typography, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  item: {
    padding: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.divider}`
      }
    },
    [theme.breakpoints.down('sm')]: {
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.divider}`
      }
    }
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  overline: {
    marginTop: theme.spacing(1)
  }
}));

const Statistics = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const { t } = useTranslation('overview');

  // Revenue + order count are aggregated server-side (GET /orders/stats) so they
  // reflect ALL orders, not just the first page that used to be loaded here.
  const stats = useSelector(state => state.orders.stats);
  const totalProducts = useSelector(state => state.products.totalProducts);

  const currencyFormatter = new Intl.NumberFormat('vi', {
    style: 'currency',
    currency: 'VND'
  });

  const totalRevenue = stats.totalRevenue || 0;
  const totalOrder = stats.totalOrders || 0;

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="center"
        container
        justify="space-between"
      >
        <Grid
          className={classes.item}
          item
          md={4}
          sm={6}
          xs={12}
        >
          <Typography variant="h2">{currencyFormatter.format(totalRevenue)}</Typography>
          <Typography
            className={classes.overline}
            variant="overline"
          >
            {t('statistics.totalRevenue')}
          </Typography>
        </Grid>
        <Grid
          className={classes.item}
          item
          md={4}
          sm={6}
          xs={12}
        >
          <Typography variant="h2">{totalProducts}</Typography>
          <Typography
            className={classes.overline}
            variant="overline"
          >
            {t('statistics.totalProduct')}
          </Typography>
        </Grid>
        <Grid
          className={classes.item}
          item
          md={4}
          sm={6}
          xs={12}
        >
          <Typography variant="h2">{totalOrder}</Typography>
          <Typography
            className={classes.overline}
            variant="overline"
          >
            {t('statistics.totalOrder')}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

Statistics.propTypes = {
  className: PropTypes.string
};

export default Statistics;
